import { SHOW_TOAST_MESSAGE, CLEAR_TOAST_DATA } from './toast-actions';

const defaultState = {
    messageData: undefined
};
export default function (state = defaultState, action) {
    if (!action) return state;
    const { type, payload } = action;

    switch (type) {
    case SHOW_TOAST_MESSAGE: {
        return {
            messageData: payload
        };
    }
    case CLEAR_TOAST_DATA: {
        return { defaultState };
    }
    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./components/toast/toast-reducer.js